import React, { ReactNode } from "react";

import {
  NonPlayableVideoOverlay,
  NonPlayableVideoText
} from "./NonPlayableStyles";

export const NonPlayableContent = ({ children }: { children: ReactNode }) => (
  <NonPlayableVideoOverlay>
    <NonPlayableVideoText>{children}</NonPlayableVideoText>
  </NonPlayableVideoOverlay>
);
